import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#003d82] text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/kfg763no_image001%202_Nero_AI_Image_Upscaler_Photo_Face.png"
              alt="Litoral Norte"
              className="h-14 w-auto mb-4"
            />
            <p className="text-gray-300 text-sm mb-4">
              Transporte rodoviário de passageiros e serviços de turismo nacional e internacional, desde 2003.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#f5a623]">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" onClick={scrollToTop} className="text-gray-300 hover:text-[#f5a623] transition-colors text-sm">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/sobre" onClick={scrollToTop} className="text-gray-300 hover:text-[#f5a623] transition-colors text-sm">
                  Sobre Nós
                </Link>
              </li>
              <li>
                <Link to="/servicos" onClick={scrollToTop} className="text-gray-300 hover:text-[#f5a623] transition-colors text-sm">
                  Serviços
                </Link>
              </li>
              <li>
                <Link to="/horarios" onClick={scrollToTop} className="text-gray-300 hover:text-[#f5a623] transition-colors text-sm">
                  Horários Carreiras
                </Link>
              </li>
              <li>
                <Link to="/galeria" onClick={scrollToTop} className="text-gray-300 hover:text-[#f5a623] transition-colors text-sm">
                  Galeria
                </Link>
              </li>
              <li>
                <Link to="/recrutamento" onClick={scrollToTop} className="text-gray-300 hover:text-[#f5a623] transition-colors text-sm">
                  Recrutamento
                </Link>
              </li>
              <li>
                <Link to="/contacto" onClick={scrollToTop} className="text-gray-300 hover:text-[#f5a623] transition-colors text-sm">
                  Contactos
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#f5a623]">Serviços</h3>
            <ul className="space-y-2">
              <li className="text-gray-300 text-sm">Carreiras UNIR</li>
              <li className="text-gray-300 text-sm">Carreiras CIM Cávado</li>
              <li className="text-gray-300 text-sm">Alugueres Ocasionais</li>
              <li className="text-gray-300 text-sm">Alugueres Especializados</li>
              <li className="text-gray-300 text-sm">Turismo</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#f5a623]">Contactos</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#f5a623] flex-shrink-0 mt-1" />
                <div className="text-gray-300 text-sm">
                  <div>{companyInfo.address.street}</div>
                  <div>{companyInfo.address.lojas}</div>
                  <div>{companyInfo.address.postal} {companyInfo.address.city}</div>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#f5a623] flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-gray-300 text-sm hover:text-[#f5a623] transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#f5a623] flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-gray-300 text-sm hover:text-[#f5a623] transition-colors">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Clock size={18} className="text-[#f5a623] flex-shrink-0" />
                <span className="text-gray-300 text-sm">{companyInfo.hours.weekdays}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-300">
            <p>&copy; {currentYear} {companyInfo.fullName}. Todos os direitos reservados.</p>
            <div className="flex gap-6">
              <Link to="/privacidade" className="hover:text-[#f5a623] transition-colors">
                Política de Privacidade
              </Link>
              <Link to="/termos" className="hover:text-[#f5a623] transition-colors">
                Termos de Uso
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};